import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import LoblawsSkusForm from "../../../components/forms/setup/sunLoblawsSkus/LoblawsSkusForm";
import { BannerNotificationType } from "../../../components/SimpleBanner";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";

export function SunLoblawsSkusViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [loblawsSkus, setLoblawsSkus] = useState({ data: [] });

  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const user_id = localStorage.getItem("id");

  const getSunLoblawsSkus = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`sunLoblawsSkus`, payload);
    setLoading(false);
    if (callResult.success) {
      setLoblawsSkus(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createLoblawsSku = async function (values) {
    const payload = { ...values, user_id: user_id };
    let callResult = await makePostApiCall("createSunLoblawsSku", payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Loblaws SKU added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getSunLoblawsSkus("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateLoblawsSku = async function (loblawsSku, values, index) {
    const payload = { ...values, id: loblawsSku.id };
    let callResult = await makePutApiCall(`sunLoblawsSkus/${loblawsSku.id}`, payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Loblaws SKU updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getSunLoblawsSkus("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddLoblawsSkuSlideOver = () => {
    setSlideOver({
      childComponent: (
        <LoblawsSkusForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createLoblawsSku}
        />
      ),
      open: true,
    });
  };

  const viewLoblawsSkuDetails = async function (loblawsSku, index) {
    setSlideOver({
      childComponent: (
        <LoblawsSkusForm
          loblawsSku={loblawsSku}
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          actionCall={updateLoblawsSku}
        />
      ),
      open: true,
    });
  };

  const deleteLoblawsSku = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteSunLoblawsSku/${id}`, {});
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getSunLoblawsSkus("", 1);
      setShowSimpleNotification({
        show: true,
        title: callResult.data.message || "Loblaws SKU deleted",
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteLoblawsSku = function (loblawsSku, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteLoblawsSku(loblawsSku.id, index)}
          message={`Are you sure you want to delete the SKU mapping for ${loblawsSku.solmaz_plu}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    askDeleteLoblawsSku,
    emptyModal,
    getSunLoblawsSkus,
    loading,
    loblawsSkus,
    openAddLoblawsSkuSlideOver,
    setEmptyModelOpen,
    setSlideOver,
    setShowSimpleNotification,
    slideOver,
    showSimpleNotification,
    viewLoblawsSkuDetails,
  };
}

